import { useMemo } from 'react'
import { useIsSendByRelayer } from './useIsSendByRelayer'
import { useTokenUSDPriceWithAmount } from '~/hooks/useTokenPrice'
import { useSpotSwapPair, useSpotSwapAmount } from '~/state/dex/hooks'
import { AddressZero } from '@ethersproject/constants'
import { formatEther } from 'viem'
import { FixedPointNumber } from '~/utils/fixedPoint'
import { NotificationLevel } from '~/components/NotificationBar'

/**
 * use for send by self
 */
export const useCalcGasFeeRisk = (gasFeeTokenAmount = 0n) => {
  const [inputToken] = useSpotSwapPair()
  const { inputAmount } = useSpotSwapAmount()
  const isSendByRelayer = useIsSendByRelayer()

  const inputAmountValue = useTokenUSDPriceWithAmount(
    inputToken?.address,
    inputAmount,
    false,
  ) as FixedPointNumber

  const gasFeeValue = useTokenUSDPriceWithAmount(
    AddressZero,
    formatEther(!isSendByRelayer ? gasFeeTokenAmount : 0n),
    false,
  ) as FixedPointNumber

  const { level, percentage } = useMemo(() => {
    let level: NotificationLevel = 'info'
    if (inputAmountValue.lte(0)) return { level }

    const gasFeePercentage = gasFeeValue
      .div(inputAmountValue)
      .times(100)
      .toNumber()

    if (gasFeePercentage >= 50) {
      level = 'risk'
    } else if (gasFeePercentage >= 20) {
      level = 'warning'
    }
    return { level, percentage: gasFeePercentage }
  }, [inputAmountValue, gasFeeValue])

  return { level, percentage }
}
